export default __webpack_public_path__ + "assets/disabled-selected-checkbox.d4c854ef.webp";